import styled from 'styled-components';

import {
  Icon,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Main = styled.div`
  width: 320px;
  display:flex;
  flex-direction:column;
  align-items:center;
  border-radius:8px;
  background-color: #fff;
`;

export const Header = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  background: ${props => props.theme.colors.primary};
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

export const HeaderContent = styled.p`
  color: rgb(255,255,255);
  font-size: 20px;
  font-weight: bold;
  margin: 0
`;

export const ContentWrapper = styled.div`
  text-align:center;
  padding-top:10px;
`;

export const Content = styled.div`
  width:85%;
  font-size:15px;
  margin: 0 auto;
`;

export const ButtonWrapper = styled(Flex).attrs({
  align: 'center',
  justify: 'space-around',
})`
  width: 100%;
  padding-top:25px;
  padding-bottom:25px;
`;

export const Button = styled.button`
  width:60px;
  height:30px;
  text-align:center;
  color: rgb(255, 255, 255);
  background: ${props => props.theme.colors.primary};
  border-radius: 5px;
  outline:none;
  border:none;
  cursor:pointer;
`;

export const List = styled.ul`
  display: flex;
  flex-wrap:wrap;
  margin: 0;
  padding: 0;
  list-style-type:none;
`;

export const ListItem = styled.li`
  padding-left:5px;
`;

export const ListIcon = styled(Icon).attrs(
  props => ({
    size: '10px',
    type: 'fas fa-circle',
    color: props.isCurrent ? props.theme.colors.primary : '#bcbdc6',
  }),
)``;
